<script>
import ParticipantLeaderboard from '@/components/cards/ParticipantLeaderboard.vue'
import CountDownTeaser from '@/components/CountDownTeaser.vue'
import DiscoverMoments from '@/components/cards/DiscoverMoments.vue'
import RegisterNowTeaser from '@/components/teasers/RegisterNowTeaser.vue'
import { mapGetters } from 'vuex'
import * as modes from '@/constants/modes'
import { date } from '@/filters'
import GenericTeaserCard from '@/components/cards/GenericTeaserCard.vue'
import { getLocaleLink } from '@/util/localization'
import getPreregisterDate from '@/util/getPreregisterDate'

export default {
  name: 'ParticipateView',
  modes,
  components: {
    GenericTeaserCard,
    RegisterNowTeaser,
    DiscoverMoments,
    ParticipantLeaderboard,
    CountDownTeaser
  },
  inject: ['media'],
  data() {
    return {
      preregisterYear: getPreregisterDate()
        .getFullYear()
    }
  },
  computed: {
    ...mapGetters([
      'mode',
      'startTime',
      'globalLeader',
      'runnersIn',
      'runnersOut',
      'hasFeature'
    ])
  },
  methods: {
    getLocaleLink,
    date
  }
}
</script>

<template>
  <aside-container>
    <transition name="fade">
      <div class="view-spacing">
        <section>
          <div
            v-if="[$options.modes.LIVE, $options.modes.POST].includes(mode) && hasFeature('registerNowTeaser')"
            class="card bg-primary d-flex align-items-center justify-content-center text-white text-center p-4"
          >
            <h4
              class="text-white"
              v-text="$t('preregister.header', {year: preregisterYear})"
            />
            <p v-text="$t('preregister.text')"/>
          </div>
          <CountDownTeaser
            v-if="[$options.modes.PRE].includes(mode)"
            :date="startTime"
          />
          <div
            v-if="[$options.modes.LIVE].includes(mode) && !hasFeature('registerNowTeaser')"
            class="card bg-primary d-flex align-items-center justify-content-center text-white text-center p-4"
          >
            <h4
              class="text-white text-uppercase"
              v-text="$t('registrationCard.title')"
            />
            <h5
              class="text-white"
              v-text="$t('registrationCard.subcopy')"
            />
            <p
              style="font-size:12px"
              class="text-light-subtle"
              v-text="$t('registrationCard.text')"
            />
            <button
              class="btn btn-outline-secondary w-100 text-white"
              role="link"
              @click="$router.push({name: 'follow'})"
            >
              {{ $t('registrationCard.btnText') }}
            </button>
          </div>
          <RegisterNowTeaser v-if="hasFeature('registerNowTeaser')"/>
        </section>

        <!-- PRE -->
        <section v-if="[$options.modes.PRE].includes(mode)">
          <GenericTeaserCard
            :text="$t('prepareTeaser.text')"
            :header-text="$t('prepareTeaser.header')"
            image-src="/prepare-app-teaser.png"
            :action-link="getLocaleLink('/wflwr-app-setup')"
            :btn-text="$t('prepareTeaser.btn')"
            btn-color="btn-outline-primary"
          />
          <GenericTeaserCard
            :text="$t('oarCard.text')"
            :header-text="$t('oarCard.header')"
            image-src="/SI201905060280_news.jpg"
            :action-link="getLocaleLink('/locations')"
            :btn-text="$t('oarCard.btn')"
            btn-color="btn-outline-primary"
          />
        </section>

        <!-- POST -->
        <section v-if="[$options.modes.POST].includes(mode)">
          <GenericTeaserCard
            :text="$t('flagshipCard.text')"
            :header-text="$t('flagshipCard.header')"
            image-src="/images/vienna-flagship.jpg"
            :action-link="getLocaleLink('/locations')"
            :btn-text="$t('flagshipCard.btn')"
            btn-color="btn-outline-primary"
          />
          <ParticipantLeaderboard
            :header="$t('welcome.globalWinners')"
            :value="globalLeader"
          />
          <DiscoverMoments/>
        </section>

      </div>
    </transition>
  </aside-container>
</template>

<style scoped lang="scss">
@import "~@/scss/bootstrap/custom";

.text-light-subtle {
  color: $text-light-subtle;
}
</style>
